module.exports = __webpack_public_path__ + "static/Logo_Xplore_Compressors_negativ-26be6fbf673696eb94589f782d9f6ec4.png";